import { scriptRunner } from "@commons/domLoaded"
import {
    attachDeviceFingerprintToForm,
    generateDeviceFingerprint,
    setDeviceFingerprintToUser
} from "@commons/fingerprint"
import { handleOtpMode } from "@/src/main/resources/templates/commons/assets/js/otp"
import { attachUuidToForm } from "@commons/uuid"
import { themeComponents } from "./theme.components"
import { Screen } from "./screen"
import { ThemeService } from "./theme.service"
import { ThemeFactory } from "./theme.factory"
import { ClarityManager } from "@commons/clarity/clarityManager"

const init = () => {
    const clarityManager = new ClarityManager()
    const theme = new ThemeFactory().createTheme()
    const service = new ThemeService(theme)
    const screen = new Screen(service, themeComponents())

    clarityManager.init()
    screen.render()
}

scriptRunner(() => {
    init()
    attachUuidToForm()

    generateDeviceFingerprint().then(() => {
        setDeviceFingerprintToUser(window.DEVICE_FINGERPRINT)
        attachDeviceFingerprintToForm(window.DEVICE_FINGERPRINT)
    })
    handleOtpMode()
})
